const shared = {
    alignItems: 'center' as const,
    borderColor: '$avatarBorder',
    borderRadius: '$avatarBorder',
    borderStyle: 'solid' as const,
    borderWidth: '$avatar',
    display: 'flex' as const,
    height: '$avatar',
    justifyContent: 'center' as const,
    minWidth: '$avatar',
    width: '$avatar',
}

export const text = {
    ...shared,
    boxSizing: 'border-box',
    color: '$avatarText',
    fontSize: '$avatarText',
    variants: {
        size: {
            big: {
                borderRadius: '$avatarBigBorder',
                fontSize: '$avatarBigText',
                height: '$avatarBig',
                minWidth: '$avatarBig',
                width: '$avatarBig',
            },
            mid: {
                borderRadius: '$avatarMidBorder',
                fontSize: '$avatarMidText',
                height: '$avatarMid',
                minWidth: '$avatarMid',
                width: '$avatarMid',
            },
            small: {
                borderRadius: '$avatarSmallBorder',
                fontSize: '$avatarSmallText',
                height: '$avatarSmall',
                minWidth: '$avatarSmall',
                width: '$avatarSmall',
            },
        },
        state: {
            highlight: {
                backgroundColor: '$avatarBackgroundHighlight',
                borderWidth: '0',
                color: '$avatarTextHighlight',
            },
            unread: {
                backgroundColor: '$avatarBackgroundUnread',
                borderWidth: '0',
                color: '$avatarTextUnread',
            },
        },
    },
}

export const nativeText = {
    color: '$avatarText',
    fontSize: '$avatarText',
}

export const nativeTextContainer = {...shared}
